import PageHeader from './PageHeader'
import Pagination  from './Pagination'
import PrevPage from './PrevPage'
import TwiceUploads from './twiceUploads'
import UploadImgs from './uploadImgs'

export default {
    install: Vue => {
        Vue.component("PageHeader", PageHeader); //页面头部标题
        Vue.component("Pagination", Pagination); //页面头部标题
        Vue.component("PrevPage", PrevPage); //底部按钮
        Vue.component("TwiceUploads", TwiceUploads); //基于vant二次封装上传图片视频组件(废弃)
        Vue.component("UploadImgs", UploadImgs); // 基于vant二次封装上传图片视频组件
    }
}